import { COUNTRIES, COUNTRY_CALLING_CODES } from './countries-static';

const UNICODE_REGIONAL_BASE = 127397;

export function getCountryOptions(excludedCountries = []) {
  return {
    ...filterCountries(COUNTRIES.scandinavian, excludedCountries),
    divider: {
      label: '-------------',
      disabled: true
    },
    ...filterCountries(COUNTRIES.other, excludedCountries)
  };
}

function filterCountries(countries, excludedCountries) {
  if (excludedCountries.length === 0) return countries;
  const filtered = {};
  Object.keys(countries).forEach(key => {
    if (!excludedCountries.includes(key)) {
      filtered[key] = countries[key];
    }
  });
  return filtered;
}

export function getCountryCallingCodeOptions(): Record<
  string | 'divider',
  | string
  | {
      label: string;
      disabled: boolean;
    }
> {
  return {
    ...convertCallingCodes(COUNTRY_CALLING_CODES.scandinavian),
    divider: {
      label: '-------------',
      disabled: true
    },
    ...convertCallingCodes(COUNTRY_CALLING_CODES.other, true)
  };
}

export function getFlagEmoji(countryCode) {
  if (countryCode === 'AN') return '';

  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => UNICODE_REGIONAL_BASE + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

function convertCallingCodes(callingCodes: Record<string, string>, sort = false): Record<string, string> {
  return Object.entries(callingCodes)
    .sort(([a], [b]) => a.localeCompare(sort ? b : a))
    .reduce((options, [callingCode, prefix]) => {
      const countryCode = callingCode.replace(/-.+/, '');
      const flag = getFlagEmoji(countryCode);
      const text = `${flag} ${countryCode} +${prefix}`.trim();
      return { ...options, [callingCode]: text };
    }, {});
}
